export default "__VITE_ASSET__siDMZfeQ__"